'use strict';

require('es6-shim');

require('function.prototype.name/shim')();

require('./es2016');



//////////////////
// WEBPACK FOOTER
// ./~/airbnb-js-shims/target/es2015.js
// module id = 249
// module chunks = 35783957827783 172322841747965